import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputRightAddon,
} from "@chakra-ui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import React, { VFC } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import * as z from "zod";

import { sendMagicLinkForExtension, sendMagicLinkForWeb } from "shared/auth";

const InputsSchema = z.object({
  email: z.string().email(),
});
type Inputs = z.infer<typeof InputsSchema>;

type Props = {
  environment: "web" | "ext";
  onSuccess?: (token: string) => void;
};
const RegisterForm: VFC<Props> = ({ environment, onSuccess }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields, isSubmitting },
  } = useForm<Inputs>({
    resolver: zodResolver(InputsSchema),
  });

  const onSubmit: SubmitHandler<Inputs> = async (data: Inputs) => {
    if (environment === "web") {
      const result = await sendMagicLinkForWeb(data.email);
      if (onSuccess && result) {
        onSuccess(result);
      }
    } else {
      const result = await sendMagicLinkForExtension(data.email);
      if (onSuccess && result) {
        onSuccess(result);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl isInvalid={errors?.email !== undefined && touchedFields.email}>
        <FormLabel htmlFor="email">Login to Lokalyze with your email address:</FormLabel>

        <InputGroup size="lg">
          <Input {...register("email")} required placeholder="email address" />
          <InputRightAddon
            children={
              <Button isLoading={isSubmitting} type="submit">
                Submit
              </Button>
            }
          />
        </InputGroup>

        <FormErrorMessage>{errors.email?.message}</FormErrorMessage>
      </FormControl>
    </form>
  );
};

export default RegisterForm;
